var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.attachments),function(attachment){return _c('rn-attachment-preview',{key:attachment.id,staticClass:"o-attachment-previews",attrs:{"title":attachment.title,"type":attachment.type,"callback":attachment.callback}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }